import React, { useEffect, useState } from 'react';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import Button from '../../../../components/button/Button';
import { arrayToCsv, download } from '../../../../utils/downloadUtils';
import { Adresse, Mandant } from '../../../../api';
import * as XLSX from 'xlsx';
import { importAdressen } from '../../../../redux/actions/admin';
import Toolbar from '../../../../components/toolbar/Toolbar';
import Modal from '../../../../components/modal/Modal';
import { getAllMandanten } from '../../../../redux/actions/admin';
import { processData } from '../../../../utils/uploadUtils';

interface AdressenimportProps {
  importAdressen: (adressen: Adresse[], mandant_id: number) => void;
  getAllMandanten: (searchString: string) => void;
  adrImportMandanten: Mandant[];
}

const Adressenimport = (props: AdressenimportProps) => {
  const [importedAdressen, setImportedAdressen] = useState<Adresse[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [searchString, setSearchString] = useState('');
  const [selectedMandant, setSelectedMandant] = useState<Mandant>();
  const [mandantenLabel, setMandantenLabel] = useState<string>('');
  const [Mandanten, setMandanten] = useState<Array<any>>([{}]);
  const [datei, setDatei] = useState('Datei auswählen');
  const vorlageHeaders = [
    'fremdnummer',
    'name',
    'zeile2',
    'zeile3',
    'strasse',
    'hausnummer',
    'zusatz',
    'ortsteil',
    'ort',
    'plz',
    'lkz',
    'kontakt',
    'telefon',
  ];

  const exportToExcel = () => {
    const adresseVorlage = arrayToCsv(vorlageHeaders);
    download(adresseVorlage, 'Adresse-Vorlage.csv');
  };

  useEffect(() => {
    const newMandanten = [...props.adrImportMandanten];
    setMandanten(newMandanten);
  }, [props.adrImportMandanten]);

  useEffect(() => {
    props.getAllMandanten(searchString);
  }, [searchString]);

  const handleClose = () => {
    setShowModal(false);
  };

  const onClickImport = () => {
    if (selectedMandant) {
      props.importAdressen(importedAdressen, selectedMandant?.id ?? -1);
    } else {
      setMandantenLabel('Bitte Mandant auswählen');
    }
    handleClose();
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files
      ? e.target.files[0]
      : new File(['Error'], 'error.csv');
    const reader = new FileReader();
    reader.onload = event => {
      /* Parse data */
      const bstr = event.target?.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const importedAdressen = XLSX.utils.sheet_to_csv(ws);
      processData(importedAdressen, setImportedAdressen);

      setDatei(file?.name ?? '');
    };
    reader.readAsBinaryString(file);
  };

  const mandantenAuswahl = () => {
    props.getAllMandanten(searchString);
    setShowModal(true);
  };

  const isSelected = (id1: number | undefined, id2: number | undefined) => {
    return id1 === id2;
  };
  const fuelleMandantenLabel = (mandant: Mandant | undefined) => {
    setShowModal(false);
    if (mandant) {
      setMandantenLabel(
        `${mandant.name}\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n${
          mandant.adresse?.matchcode
        }\n${mandant.adresse?.name}\n${mandant.adresse?.zeile2 ?? ''}\n${
          mandant.adresse?.strasse
        } ${mandant.adresse?.hausnummer ?? ''}\n${
          mandant.adresse?.land?.lkz
        } - ${mandant.adresse?.plz} ${mandant.adresse?.ort}`
      );
    } else {
      setMandantenLabel(' ');
    }
  };

  const MandantenList = (mandant: Mandant) => {
    return (
      <li
        key={`'md: ${mandant.id}`}
        title={`${mandant.name}\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n${
          mandant.adresse?.matchcode
        }\n${mandant.adresse?.name}\n${mandant.adresse?.zeile2 ?? ''}\n${
          mandant.adresse?.strasse
        } ${mandant.adresse?.hausnummer ?? ''}\n${
          mandant.adresse?.land?.lkz
        } - ${mandant.adresse?.plz} ${mandant.adresse?.ort}`}
        className={`select-list-option ${
          isSelected(selectedMandant?.id, mandant.id) && 'selected'
        }`}
        onClick={() => {
          setSelectedMandant(mandant);
        }}
      >
        {` ${mandant.name} (${mandant.adresse?.matchcode})`}
      </li>
    );
  };

  return (
    <GridCellWrapper
      classes='adressenimport'
      label='Adressenimport'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <Button
        tooltip='Mandantenauswahl'
        classes={'iconButton'}
        key={1}
        onClickHandler={() => {
          mandantenAuswahl();
        }}
      >
        <i className='far fa-dot-circle fa-2x'></i>
        &nbsp;Mandant auswählen
      </Button>
      <div className={'mandantenLabel'}>{mandantenLabel}</div>
      <div>
        <label className={'fileselectionlabel'}>
          <input
            type='file'
            accept='.csv'
            onChange={e => handleFileUpload(e)}
          />
          <i className='fas fa-search fa-2x'></i>&nbsp;
          {datei}
        </label>
        <Button
          disabled={!!(importedAdressen.length === 0 || !selectedMandant)}
          classes={'iconButton'}
          onClickHandler={() => onClickImport()}
        >
          <i className='fas fa-plus-circle fa-2x'></i> &nbsp;Adressen
          importieren
        </Button>
      </div>
      <hr />
      <Button
        tooltip='Adresse-Vorlage herunterladen'
        classes={'iconButton'}
        key={3}
        onClickHandler={() => {
          exportToExcel();
        }}
      >
        <i className='far fa-arrow-alt-circle-down fa-2x'></i>
        &nbsp;Adresse-Vorlage herunterladen
      </Button>
      <Modal
        show={showModal}
        closeHandler={() => setShowModal(false)}
        titel='Mandant auswählen'
      >
        <div className='modalliste'>
          <Toolbar>
            <div className='searchbar'>
              <i className='fas fa-search fa-lg' />
              <input
                type='text'
                placeholder={'...'}
                title={'mindestens 2 Zeichen angeben'}
                id='search-input'
                value={searchString}
                onChange={e => setSearchString(e.target.value)}
              />
            </div>
          </Toolbar>
          <ul>
            {Mandanten.map(fm => {
              return MandantenList(fm);
            })}
          </ul>
        </div>
        <div className='modal-btn-group'>
          <button
            className='modal-btn'
            key={4}
            onClick={() => {
              fuelleMandantenLabel(selectedMandant);
            }}
          >
            OK
          </button>
          <button className='modal-btn' key={5} onClick={() => handleClose()}>
            Abbrechen
          </button>
        </div>
      </Modal>
    </GridCellWrapper>
  );
};
const mapStateToProps = (state: StateModel) => ({
  adrImportMandanten: state.Admin.adrImportMandanten,
});

export default connect(mapStateToProps, {
  importAdressen,
  getAllMandanten,
})(Adressenimport);
